import React from 'react';
import { Link } from 'react-router-dom';

// Terms of Service page component
const TermsPage = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1 className="privacy-title">Terms of Service</h1>

        <div className="privacy-content">
          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">1</span>
              <h2>Acceptance of Terms</h2>
            </div>
            <p>
              By accessing and using getphotoshoot.ai ("Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">2</span>
              <h2>Description of Service</h2>
            </div>
            <p>
              getphotoshoot.ai is an AI-powered jewelry photography service that allows users to transform jewelry photos into professional model presentations. The Service utilizes artificial intelligence to generate images based on user-uploaded content.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">3</span>
              <h2>User Accounts and Registration</h2>
            </div>
            <p>
              To use certain features of the Service, you must register for an account. You agree to:
            </p>
            <ul className="terms-list">
              <li>Provide accurate, current, and complete information during registration</li>
              <li>Maintain and update your information to keep it accurate, current, and complete</li>
              <li>Maintain the security of your account credentials</li>
              <li>Accept responsibility for all activities under your account</li>
            </ul>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">4</span>
              <h2>Credits and Payment</h2>
            </div>
            <p>
              The Service operates on a credit-based system:
            </p>
            <ul className="terms-list">
              <li>New users receive initial free credits as specified at the time of registration</li>
              <li>Credits are required to generate images</li>
              <li>Credits may expire or be subject to additional terms</li>
              <li>All purchases are final unless otherwise stated</li>
            </ul>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">5</span>
              <h2>Acceptable Use</h2>
            </div>
            <p>You agree <strong>NOT</strong> to use the Service to:</p>
            <ul className="terms-list">
              <li>Upload content that is illegal, harmful, or violates any laws</li>
              <li>Upload content that infringes on intellectual property rights</li>
              <li>Upload offensive, defamatory, or inappropriate content</li>
              <li>Attempt to reverse engineer or interfere with the Service</li>
              <li>Use automated systems or bots to access the Service</li>
              <li>Share your account credentials with others</li>
            </ul>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">6</span>
              <h2>Intellectual Property</h2>
            </div>
            <p>
              All content generated through the Service, including but not limited to images, is the property of getphotoshoot.ai or its licensors. Users retain ownership of their original uploaded content. Generated images may be used for commercial purposes subject to the Service's license terms.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">7</span>
              <h2>Privacy</h2>
            </div>
            <p>
              Your use of the Service is also governed by our <Link to="/privacy" className="terms-link">Privacy Policy</Link>. Please review our Privacy Policy to understand our practices regarding the collection and use of your information.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">8</span>
              <h2>Limitation of Liability</h2>
            </div>
            <p>
              getphotoshoot.ai shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the Service. The total liability of getphotoshoot.ai shall not exceed the amount you paid for the Service in the 12 months prior to the claim.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">9</span>
              <h2>Termination</h2>
            </div>
            <p>
              We may terminate or suspend your account and access to the Service immediately, without prior notice, for any reason, including if you breach these Terms of Service.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">10</span>
              <h2>Changes to Terms</h2>
            </div>
            <p>
              We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through the Service. Your continued use of the Service after such modifications constitutes acceptance of the updated terms.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">11</span>
              <h2>Contact Information</h2>
            </div>
            <p>
              If you have any questions about these Terms of Service, please contact us through the Service's support channels.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;

